import { render, staticRenderFns } from "./PersonalizationContacts.vue?vue&type=template&id=4d7f7422&scoped=true"
import script from "./PersonalizationContacts.vue?vue&type=script&lang=js"
export * from "./PersonalizationContacts.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationContacts.vue?vue&type=style&index=0&id=4d7f7422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7f7422",
  null
  
)

export default component.exports